import axios from 'axios';
import { getBaseUrlAnalista, ensureProtocol } from '../config/backend';

function getAuthHeaders() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: token.startsWith('Bearer ') ? token : 'Bearer ' + token } : {};
}

function baseUrl() {
  return getBaseUrlAnalista() || ensureProtocol(localStorage.getItem('ipBackend2') || '');
}

export async function fetchRagEstatisticas() {
  const url = baseUrl() ? baseUrl() + '/rag/estatisticas' : '/rag/estatisticas';
  const { data } = await axios.get(url, { headers: getAuthHeaders() });
  return data;
}

export async function fetchRagChunks(params = {}) {
  const url = baseUrl() ? baseUrl() + '/rag/chunks' : '/rag/chunks';
  const { data } = await axios.get(url, { headers: getAuthHeaders(), params });
  return Array.isArray(data) ? data : [];
}

export async function fetchRagVerificar() {
  const url = baseUrl() ? baseUrl() + '/rag/verificar' : '/rag/verificar';
  const { data } = await axios.get(url, { headers: getAuthHeaders() });
  return data;
}

export async function reindexarRag(body = {}) {
  const url = baseUrl() ? baseUrl() + '/rag/reindexar' : '/rag/reindexar';
  const { data } = await axios.post(url, body, { headers: getAuthHeaders() });
  return data;
}
